import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getMixtureEntriesSelector = createSelector(
  mixtureEntries => mixtureEntries.mixtureEntries,
  (mixtureEntriesById) => getArrayOfObjectValues(mixtureEntriesById)
);